import script from "./music_chat.vue?vue&type=script&setup=true&lang=ts"
export * from "./music_chat.vue?vue&type=script&setup=true&lang=ts"

import "./music_chat.vue?vue&type=style&index=0&id=db0040ce&lang=scss&scoped=true"
import "./music_chat.vue?vue&type=style&index=1&id=db0040ce&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db0040ce"]])

export default __exports__